/**
 * Likőr íz növényi
 */
export type LiqueurHerbalFlavor =
  | 'MINT'
  | 'GENTIAN'
  | 'ANISE'
  | 'WORMWOOD'
  | 'MEDICINAL_BALM'
  | 'OTHER';

export const LiqueurHerbalFlavor = {
  Mint: 'MINT' as LiqueurHerbalFlavor,
  Gentian: 'GENTIAN' as LiqueurHerbalFlavor,
  Anise: 'ANISE' as LiqueurHerbalFlavor,
  Wormwood: 'WORMWOOD' as LiqueurHerbalFlavor,
  MedicinalBalm: 'MEDICINAL_BALM' as LiqueurHerbalFlavor,
  Other: 'OTHER' as LiqueurHerbalFlavor,
};
